import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import useIsMounted from "../../hooks/useIsMounted";

const SimpleImage = ({
  imageSrc,
  centerImage = true,
  className = "",
  altText = ""
}: {
  imageSrc: string;
  centerImage?: boolean;
  className?: string;
  altText?: string;
}) => {
  const isMounted = useIsMounted();
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    if (imageSrc) {
      const loader = document.createElement("img");
      loader.onload = () => {
        if (isMounted()) setImageLoaded(true);
      };
      loader.src = imageSrc;
      return () => {
        loader.onload = null;
      };
    }
  }, [imageSrc, isMounted]);

  return (
    <div
      className={className}
      style={{
        display: "block",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        height: "100%",
        width: "100%",
        background: "#eee"
      }}
    >
      <AnimatePresence>
        {imageLoaded && (
          <motion.img
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 1 }}
            transition={{ duration: 1 }}
            src={imageSrc}
            alt={altText}
            aria-hidden={altText === "" ? "true" : "false"}
            style={{
              display: "block",
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              height: "100%",
              width: "100%",
              objectFit: "cover",
              objectPosition: centerImage ? "center center" : "center bottom"
            }}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default SimpleImage;
